export const DELETE_PROJECT_MODAL_TITLE = 'delete-project-modal-title'
export const DELETE_PROJECT_MODAL_DESC = 'delete-project-modal-description'
export const DELETE_PROJECT_MODAL_CONFIRM_BUTTON = 'delete-project-modal-confirm-button'
export const DELETE_PROJECT_MODAL_CANCEL_BUTTON = 'delete-project-modal-cancel-button'
